export default {
  setUsers(state, { payload }) {
    state.allUsers = payload.data.list;
  },

  setFlashErrorMessage(state, payload) {
    state.flashErrorMessage = payload;
    state.flashError = payload !== '';
  },

  clearUsers(state) {
    state.allUsers = [];
    state.totalUsers = 0;
  },

  setDetailMerchant(state, { payload }) {
    state.usersMerchantDetail = payload;
    state.usersMerchant = payload;
  },

  clearUsersMerchant(state) {
    state.usersMerchant = [];
    state.totalUsersMerchant = 0;
  },

  clearErrors(state) {
    state.errors = [];
  },

  setErrors(state, payload) {
    state.errors = payload;
  },

  setTotalUsers(state, { payload }) {
    state.totalUsers = parseInt(payload.data.countdata, 10);
    state.totalPage = parseInt(payload.data.totalPage, 10);
  },

  setLoading(state, loading) {
    state.loading = loading;
  },

  clearErrorVariable(state, variable) {
    state.errors[variable] = [];
  },

  editUser(state, { payload, index }) {
    Object.assign(state.allUsers[index], payload);
  },

  setBioList(state, { payload }) {
    state.BioDetailList = payload.data.list;
    state.isDisabledBlock = payload.data.isDisabledBlock;
  },

  setTotalBio(state, { payload }) {
    state.BioTotalList = parseInt(payload.data.countdata, 10);
  },

  clearBioList(state) {
    state.BioDetailList = [];
    state.BioTotalList = 0;
  },
};